import React, { useEffect, useState } from 'react';
import DashboardLayout from '../layouts/dashboard';
import { CredusButton, CredusText, CredusWrapper } from 'ui';
import ReportTab from '../modules/report/components/ReportTab';
import { Outlet, useLocation } from 'react-router';
import ConfirmModal from '../modules/report/components/modals/ConfirmModal';
import SuspendModal from '../modules/report/components/modals/SuspendModal';
import { BreadCrumb } from './TestManagement';
import { BiChevronRight } from 'react-icons/bi';
import useTestResult from '../modules/report/hooks/useTestResult';
import { Link } from 'react-router-dom';

const ReportScreen = () => {
  const [tabValue, setTabValue] = useState<number>(0);
  const [submission, setSubmission] = useState<boolean>(false);
  const [suspend, setSuspend] = useState<boolean>(false);
  const location = useLocation();
  const { candidateResultId, data } = useTestResult();

  useEffect(() => {
    if (location?.pathname?.includes('proctoring')) {
      setTabValue(1);
    }
  }, []);

  const onConfirmModalOpen = () => {
    setSubmission(!submission);
  };
  const onSuspendModalOpen = () => {
    setSuspend(!suspend);
  };

  return (
    <DashboardLayout
      breadCrumbs={
        <BreadCrumb>
          <Link to="/dashboard" className='breadcrumb-link'>
            <CredusText color={'#7a7a7a'} size="sm">
              Dashboard
            </CredusText>
          </Link>
          <BiChevronRight color={'#7a7a7a'} />
          <Link to="/report" className='breadcrumb-link'>
            <CredusText color={'#7a7a7a'} size="sm">
              View Report
            </CredusText>
          </Link>
          <BiChevronRight color={'#7a7a7a'} />
          <CredusText color={'#7a7a7a'} size="sm">
            {candidateResultId}
          </CredusText>
        </BreadCrumb>
      }
    >
      <CredusWrapper padding="2.12rem 3.12rem" radius="5px" bg="#fff">
        <CredusWrapper display="flex" justify="space-between" align="center">
          <CredusText size="xl" weight="bold">
            {data?.subject}
          </CredusText>
          <CredusWrapper gap="0.9rem" display="flex" align="center">
            <CredusButton variant="tertiary" onClick={onConfirmModalOpen}>
              Upload
            </CredusButton>
            <CredusButton variant="primary" onClick={onSuspendModalOpen}>
              Suspend
            </CredusButton>
          </CredusWrapper>
        </CredusWrapper>
        <CredusWrapper
          mt="0.2rem"
          display="flex"
          justify="space-between"
          align="center"
        >
          <CredusText size="xs" weight="medium">
            (Attempt 1 of 1)
          </CredusText>
        </CredusWrapper>
        <ReportTab setTabValue={setTabValue} tabValue={tabValue} />
        <CredusWrapper mt={tabValue === 0 ? '2.5rem' : '3.31rem'}>
          <Outlet context={{ data }} />
        </CredusWrapper>
      </CredusWrapper>
      {submission && (
        <ConfirmModal
          submission={submission}
          setSubmission={setSubmission}
          onConfirmModalOpen={onConfirmModalOpen}
        />
      )}
      {suspend && (
        <SuspendModal
          suspend={suspend}
          setSuspend={setSuspend}
          onSuspendModalOpen={onSuspendModalOpen}
        />
      )}
    </DashboardLayout>
  );
};

export default ReportScreen;
